import { Field as ArkField } from '@ark-ui/react/field'

import type { IconName } from '@raiadrogasil/pulso-icons'

import { Icon } from '~/components/icon'

import { cn } from '~/utils/cn'
import type { VariantProps } from '~/utils/tv'

import { helperTextStyles } from './helper-text.styles'

type IconColor = React.ComponentProps<typeof Icon>['color']

type HelperTextBaseProps = Omit<
  React.ComponentProps<typeof ArkField.HelperText>,
  'asChild'
> & {
  prefix?: IconName
}

export type HelperTextProps = HelperTextBaseProps &
  VariantProps<typeof helperTextStyles>

export function HelperText({
  children,
  className,
  prefix,
  isError,
  isDisabled,
  isReadOnly,
  ...props
}: HelperTextProps) {
  const shouldShowPrefix = isError || !!prefix

  function getColorPrefix(): IconColor {
    const stateColorMap = [
      [isError, 'colorTextDangerAlternative'],
      [isDisabled, 'colorTextNeutralDisabled'],
      [isReadOnly, 'colorTextNeutralReadonly'],
    ] as Array<[boolean, IconColor]>

    for (const [condition, color] of stateColorMap) {
      if (condition) return color
    }

    return 'colorTextNeutralAlternative'
  }

  return (
    <ArkField.HelperText
      {...props}
      className={cn(
        helperTextStyles({
          className,
          isError,
          isDisabled,
          isReadOnly,
        })
      )}
    >
      {shouldShowPrefix && (
        <Icon
          symbol={isError ? 'rdicon-warning-circle' : prefix}
          size="tiny"
          color={getColorPrefix()}
        />
      )}

      <div className={cn('line-clamp-2 text-ellipsis')}>{children}</div>
    </ArkField.HelperText>
  )
}
